<template>
  <div class="post-content-type">
    <div v-if="data && data.content && data.content.translations">
      <h5>
        Фотоальбом {{ data.content.title }}
        <span v-if="data.content.season"
          >({{ data.content.season.title }})</span
        >
      </h5>
      <!-- <p v-for="(album_title, key) in data.content.translations" :key="key">
             <span class="text-info"> {{album_title.locale}}:</span>   {{album_title.title}}
          </p> -->
      <img :src="image" />

      <div>
        <br /><button
          class="btn btn-sm btn-warning"
          @click="openObject(data.content.id)"
        >
          Посмотреть
        </button>
      </div>
    </div>
    <button
      class="btn btn-sm btn-danger item-delete"
      @click="$emit('remove', index)"
    >
      <i class="ti-trash"></i>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    index: {
      default: null,
    },
    data: {
      default: null,
    },
  },
  methods: {
    openObject(id) {
      const element = `item_album`;
      let query = Object.assign({}, this.$route.query);
      if (query[element] == id) {
        return false;
      }
      if (query[element]) {
        delete query[element];
      }
      query[element] = id;
      setTimeout(() => {
        this.$router.replace({ query: query });
      }, 20);
    },
  },
  data: () => ({
    image: "",
  }),
};
</script>
